export default {
    title: '國外旅遊定型化契約'
}
